import { render, staticRenderFns } from "./AccessControl.vue?vue&type=template&id=10b7343e&"
import script from "./AccessControl.vue?vue&type=script&lang=ts&"
export * from "./AccessControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports